import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authenticatedUserSlice from './authenticatedUserSlice';
import layoutSlice from './layoutSlice';
import adminUserSectionStaticContentSlice from './sitecoreStaticContent/adminUserSectionStaticContentSlice';
import commonStaticContentSlice from './sitecoreStaticContent/commonStaticContentSlice';


const persistRootConfig = {
  version: 1,
  key: "mpg_next_admin_root_v1",
  storage,
  whitelist: []
};

const persistAuthConfig = {
  version: 1,
  key: "mpg_next_admin_auth_v1",
  storage,
  whitelist: ['authenticatedUserSlice']
};
export const authReducer = combineReducers({
  authenticatedUserSlice
})

const persistStaticContentConfig = {
  version: 1,
  key: "mpg_next_admin_static_content_v1",
  storage,
  whitelist: []
};
export const staticContentReducer = combineReducers({
  commonStaticContentSlice,
  adminUserSectionStaticContentSlice,

})

const persistAppConfig = {
  version: 1,
  key: "mpg_next_admin_app_v1",
  storage, whitelist: ['layoutSlice']
};
export const appReducer = combineReducers({
  layoutSlice
})

export const rootReducer = combineReducers({
  auth: persistReducer(persistAuthConfig, authReducer),
  app: persistReducer(persistAppConfig, appReducer),
  staticContent: persistReducer(persistStaticContentConfig, staticContentReducer),
});

export default persistReducer(persistRootConfig, rootReducer);
